import React from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Notification.css";

/**
 * Universal toast notification trigger configured to remain visible indefinitely
 * until the user manually clicks the close (×) button or dismisses it.
 */
export const showToast = (message, options = {}) => {
  if (!message) return;
  const opts = typeof options === "string" ? { type: options } : { ...options };
  const type = (opts.type || "default").toLowerCase();

  const toastConfig = {
    autoClose: false,
    closeOnClick: true,
    closeButton: true,
    transition: Slide,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    hideProgressBar: true,
    ...opts,
    autoClose: false,
  };

  if (type === "success" && toast.success) {
    return toast.success(message, toastConfig);
  } else if (type === "error" && toast.error) {
    return toast.error(message, toastConfig);
  } else if (type === "warning" && toast.warning) {
    return toast.warning(message, toastConfig);
  } else if (type === "info" && toast.info) {
    return toast.info(message, toastConfig);
  } else {
    return toast(message, toastConfig);
  }
};

export const Notification = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={false}
      transition={Slide}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick={true}
      closeButton={true}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={true}
      pauseOnHover={true}
      limit={5}
      className="ahd-toast-container"
      toastClassName="ahd-toast"
      bodyClassName="ahd-toast-body"
      progressClassName="ahd-toast-progress"
    />
  );
};

export default Notification;
